module.exports = __webpack_public_path__ + "img/sign-68.2c7f6d68.jpg";